'use client';

import { usePathname } from 'next/navigation';
import { useIsPresentationTool } from 'next-sanity/hooks';

export function DisableDraftMode() {
  const pathname = usePathname();
  const isPresentationTool = useIsPresentationTool();

  if (isPresentationTool === true) {
    return null;
  }

  const redirectTo = pathname || '/blog';

  return (
    <a
      href={`/api/draft-mode/disable?redirect=${encodeURIComponent(redirectTo)}`}
      className="fixed bottom-4 right-4 z-50 rounded-md bg-zinc-900 px-4 py-2 text-sm text-white shadow-lg"
    >
      Disable draft mode
    </a>
  );
}
